import clsx from 'clsx'
import React from 'react'

import Styles from './BurgerButton.module.scss'

type Props = {
  isOpen: boolean
  onClick: () => void
  className?: string
  theme?: 'light' | 'dark'
  size?: 'small' | 'big'
}

const BurgerButton = ({
  isOpen,
  onClick,
  className,
  theme = 'light',
  size = 'small'
}: Props) => {
  return (
    <div
      data-testid="burger-button"
      className={clsx(Styles.burger, className, {
        [Styles.open]: isOpen,
        [Styles.dark]: theme === 'dark',
        [Styles.big]: size === 'big'
      })}
      onClick={onClick}>
      <div className={Styles.burgerLine} />
    </div>
  )
}

export default BurgerButton
